module.exports = __webpack_public_path__ + "static/media/gift.db06f286.svg";